export enum LeadApiMessage {

  ZonaCirculacionInvalida = 'No pasa validación Zona de circulación',
  ErrorServicioRunt = 'Hubo problemas para comunicarse con el servicio de Runt',
  ErrorDatosVaciosRunt = 'Error en Datos vacios Runt',
  ErrorServicioFasecolda = 'Hubo problemas para comunicarse con el servicio de Fasecolda',
  ErrorDatosVaciosFasecolda = 'Error en Datos vacios Fasecolda',
  TipoCombustibleInvalido = 'No pasa validación de tipo de combustible',
  TipoDocumentoInvalido = 'No pasa validación de tipo de documento',
  TipoUsoInvalido = 'No pasa validación de tipo de uso',
  EstadoVehiculoInvalido = 'No pasa Politica de estado de vehiculo',
  PoliticaLineaNoPermitida = 'No pasa Politica de Linea Permitida',
  SalvamentoNoSura = 'No pasa validacion de siniestro PoliticaOtraCompania',
  SalvamentoSuraUnaVez = 'No pasa validacion de siniestro',
  SalvamentoSuraNoAsegurable = 'No pasa validacion de siniestro PoliticaSura ',
  ValorMaximoAsegurado = 'No pasa validacion de valor asegurado maximo',
  ValidacionAntiguedad = 'La antigüedad es superior a 10 años',
  //Ambos errores de cilindraje van con el mismo mensaje
  ValidacionCilindraje = 'No pasa validación de movilidad',
  CilindrajeInvalido = 'No pasa validación de cilindraje mayor 250cc',



  LeadErrado = 'lead errado', // Mensaje genérico para el caso 406
  // RetomaLeadDuplicado = 'Lead duplicado', // Mensaje para retoma de lead duplicado
}
